import React from "react";
import { BodyPartsFront } from "../../bodyParts";
import { BodyParts } from "../shared/BodyParts";
import image from "./male-front.png";
import MaleImage from "./MaleImage";
const paths = {
    [BodyPartsFront.RightUpperSkull]: {
        d: `M331.516,32.962c-12.1,10-19.6,23.7-21.4,31.4c-0.3,1.4-0.6,2.9-0.9,4.6c15.5,2.2,34.2,3.4,54.3,3.4c0.1,0,0.2,0,0.3,0
    v-51.5c-0.2,0-0.3,0-0.5,0C350.716,20.862,339.916,25.962,331.516,32.962z`,
        "aria-label": "Front right upper skull",
    },
    [BodyPartsFront.LeftUpperSkull]: {
        d: `M418.416,68.862c-1.5-15.6-10.8-27.7-22.1-35.8c-10.7-7.7-23.1-11.9-32.2-12.2c-0.1,0-0.2,0-0.3,0v51.5
    C384.116,72.362,402.916,71.062,418.416,68.862z`,
        "aria-label": "Front left upper skull",
    },
    [BodyPartsFront.RightFace]: {
        d: `M354.116,134.462c1.3-1.7,5.8-2.9,7.4-1.6c0.66,0.536,1.489,0.773,2.3,0.843v-6.837c-0.988-0.13-2.119-0.488-3.5-1.207
    c-4,1-10.6-1.8-10.2-6.5c0.6-6.7,5.2-10,5.6-13.1c0.4-3.1,2.9-11.1,2.5-13.8c-0.392-2.645,0.667-10.263,5.6-10.571v-9.329
    c-0.1,0-0.2,0-0.3,0c-20.1,0-38.8-1.3-54.3-3.4c-1.3,8.4-1.9,19.7-1.6,23.6c0,0.5,0.1,1,0.1,1.5c0.3,4.7,0.9,11.1,0.6,14.6
    c2.1,7.7,6.7,23,6.7,33v0.1c0.7,5.2,1.2,12.5,3.3,18.8c3,4,22.5,23.3,44.2,23.3c0.5,0,0.9,0,1.3,0v-33.45
    c-7.103-0.374-9.078-2.917-11.3-3.75c-2.4-0.9-11.8-1.1-11-4.1C342.316,139.562,352.816,136.162,354.116,134.462z M340.816,103.062
    c-8.6,0-15.5-4.1-15.5-9.3s6.9-9.5,15.5-9.5c8.6,0,14.5,4.2,14.5,9.4S349.416,103.062,340.816,103.062z`,
        "aria-label": "Front right face",
    },
    [BodyPartsFront.LeftFace]: {
        d: `M419.516,94.162c-0.1-4.9-0.3-12.1-0.9-23.2c0-0.7-0.1-1.3-0.2-2c-15.6,2.2-34.4,3.5-54.6,3.5v9.229
    c0.102-0.006,0.195-0.029,0.3-0.029c3.7,0,6.4,4,6.1,9.9c-0.3,5.9,2.6,8.1,3.1,13.5c0.5,5.4,4.9,7.6,4.9,12.2c0,4.6-2.2,8.7-8,7.8
    c-2.244,0.869-3.812,2.147-6.4,1.807v6.837c1.155,0.1,2.271-0.15,2.8-0.443c1.7-0.9,5.6-1.9,7.9,0.8c3.7,4.4,13.2,7.3,12.8,9.7
    c-0.4,2.4-6.3,3.1-8.5,3.5c-2.2,0.4-4.6,3.2-13.2,3.2c-0.638,0-1.23-0.02-1.8-0.05v33.45c0.1,0,0.2,0,0.3,0c20.8-0.4,35.1-9,44.1-23
    c2.6-5.5,4.9-14.9,4.8-18.4c0-0.1-0.1-0.1-0.1-0.2c-0.7-5.2,4.7-28.1,5.8-32.7C419.116,104.762,419.716,103.362,419.516,94.162z
     M388.816,103.062c-8.6,0-14.5-4.1-14.5-9.3s5.9-9.5,14.5-9.5c8.6,0,15.5,4.2,15.5,9.4S397.416,103.062,388.816,103.062z`,
        "aria-label": "Front left face",
    },
    [BodyPartsFront.RightEye]: {
        d: `M340.816,103.062c8.6,0,14.5-4.2,14.5-9.4s-5.9-9.4-14.5-9.4s-15.5,4.3-15.5,9.5
    S332.216,103.062,340.816,103.062z`,
        "aria-label": "Right eye",
    },
    [BodyPartsFront.LeftEye]: {
        d: `M388.816,103.062c8.6,0,15.5-4.2,15.5-9.4s-6.9-9.4-15.5-9.4s-14.5,4.3-14.5,9.5
    S380.216,103.062,388.816,103.062z`,
        "aria-label": "Left eye",
    },
    [BodyPartsFront.RightEar]: {
        d: `M308.316,108.662c-1-1.8-4.2-5.8-8.2-1.8c-1.7,1.7-2.3,5.2-2.3,8.9c0,4.7,0.9,9.7,1.5,11.8c1,3.7,5.8,14.7,7.2,15.8
    c1.4,1.1,5.2,4.8,8.5-1.7l0,0l0,0C315.016,131.662,310.416,116.362,308.316,108.662z`,
        "aria-label": "Right ear",
    },
    [BodyPartsFront.LeftEar]: {
        d: `M422.916,140.462c1-4.7,6.8-7.5,6.9-20.8c0-0.9,0-1.8-0.1-2.8c-0.8-15.7-8-11.7-11-7.3c-1.1,4.6-6.5,27.5-5.8,32.7
    c0,0.1,0.1,0.1,0.1,0.2l0,0C416.816,148.562,421.816,145.462,422.916,140.462z`,
        "aria-label": "Left ear",
    },
    [BodyPartsFront.Nose]: {
        d: `M355.716,106.062c-0.4,3.1-5,6.4-5.6,13.1c-0.4,4.7,6.2,7.5,10.2,6.5c5,2.6,6.8,0.6,9.9-0.6c5.8,0.9,8-3.2,8-7.8
    s-4.4-6.8-4.9-12.2s-3.4-7.6-3.1-13.5s-2.4-9.9-6.1-9.9c-5.2,0-6.3,7.9-5.9,10.6S356.116,102.962,355.716,106.062z`,
        "aria-label": "Nose",
    },
    [BodyPartsFront.Mouth]: {
        d: `M374.516,134.062c-2.3-2.7-6.2-1.7-7.9-0.8c-0.9,0.5-3.5,0.9-5.1-0.4s-6.1-0.1-7.4,1.6s-11.8,5.1-12.6,8.1
    s8.6,3.2,11,4.1s4.5,3.8,13.1,3.8s11-2.8,13.2-3.2s8.1-1.1,8.5-3.5S378.216,138.462,374.516,134.062z`,
        "aria-label": "Mouth",
    },
    [BodyPartsFront.RightNeck]: {
        d: `M362.516,183.862c-21.7,0-41.2-19.3-44.2-23.3l0,0c1.6,4.7,1.7,18.9,1.3,32.2l0,0c-0.1,4.6-0.3,9.1-0.5,13.1
    c-8.5,15.2-40,24-48,27.5c2,1.7,10.7,6.6,20.9,9.5c5.2,1.5,10.8,2.4,16.1,2.2c15.7-0.8,41.2-2.2,45.3,3.7c2.1,3,6.3,4.5,10.4,4.4
    v-59.5l0,0v-9.8C363.416,183.862,363.016,183.862,362.516,183.862z`,
        "aria-label": "Front right neck",
    },
    [BodyPartsFront.LeftNeck]: {
        d: `M432.516,223.962c-16.1-7.1-24.6-15.9-25.2-18.6c-0.2-1-0.3-6.1-0.2-12.6l0,0c0.1-10.9,0.6-25.7,1.1-31.9
    c-9,14-23.3,22.6-44.1,23c-0.1,0-0.2,0-0.3,0v9.8l0,0v59.5c0.1,0,0.2,0,0.3,0l0,0h0.1l0,0c3.6-0.2,7-1.6,8.8-4.4
    c3.8-6,38-6.2,50.8-4.3c5,0.7,9.8,0.8,14.4,0.4c11-1.1,20.4-5.1,25.3-10C454.716,234.762,445.116,229.562,432.516,223.962z`,
        "aria-label": "Front left neck",
    },
    [BodyPartsFront.RightShoulder]: {
        d: `M308.416,244.962c-0.1,0-0.3,0-0.4,0c-5.3,0.3-10.9-0.7-16.1-2.2c0,0-0.1,0-0.1,0.1c-10.1-2.9-18.7-7.9-20.8-9.5
    c-8,3.5-15.5,2-26.8,4.2s-41.5,13.2-53.5,37.7c-8.1,16.5-9.6,36.6-9.6,50.6c29.5,2.8,77.3,4.5,129.6,5.2
    C307.116,302.362,306.316,273.662,308.416,244.962z`,
        "aria-label": "Front right shoulder",
    },
    [BodyPartsFront.RightArm]: {
        d: `M235.616,373.262c-2.5-15.1-5.4-29.9-8.7-44.4c-17.8-0.8-33.4-1.8-45.8-2.9c0,6.8,0.3,12.3,0.4,15.2c0,1.2,0,2.3-0.1,3.2
    l0.1,0.1c-0.4,6-2.9,8.1-7.4,14.8c-5.3,7.8-15.3,39.2-18.8,51.2c-0.5,1.7-0.9,3.2-1.2,4.6c-1.4,17.7,10.7,25.9,24.4,31.6
    c11.4,4.8,24.5,8.3,33.4,1.5c0.3-0.6,0.6-1.3,1-2c0.5-1.1,1.2-2.3,1.9-3.7c3.5-6.8,23.4-48,24-48.1l0,0
    C237.816,387.262,236.716,380.262,235.616,373.262z`,
        "aria-label": "Front right arm",
    },
    [BodyPartsFront.RightElbow]: {
        d: `M178.516,446.562c-13.7-5.7-25.8-13.9-24.4-31.6c-1.9,7.8-1.5,9.5-8.8,18.7c-5.9,7.5-15.8,29.1-22.5,48.9
    c15.9-28.2,68.5,4.7,75.5,19.9c6.2-16.3,11.1-43.7,11.5-47.2c0.2-2.4,0.8-4.3,2.1-7.2
    C203.016,454.862,189.916,451.262,178.516,446.562z`,
        "aria-label": "Front right elbow",
    },
    [BodyPartsFront.RightForearm]: {
        d: `M122.816,482.562c-3,8.7-5.3,17.1-6.5,23.8c-2,11.9-8.8,39.2-16.7,62.5c-1.7,5.1-3.6,10-5.3,14.5
    c1.7,9,32.5,23.5,42.6,18.6c1.5-2.7,2.8-5,3.7-6.6c4.7-7.5,11.9-19.3,24.9-35.3s25.5-39.8,32-55.8c0.3-0.6,0.5-1.3,0.8-2
    C191.316,487.262,138.616,454.262,122.816,482.562z`,
        "aria-label": "Front right forearm",
    },
    [BodyPartsFront.RightWrist]: {
        d: `M94.316,583.362c-5.1,13-9.8,22.7-10.5,24.1c-0.9,1.9-1.5,3.3-3,4.6c9.1,0.4,29,8.7,43,19.4
    c2.1-7.8,8.4-20.9,13-29.6C126.816,606.862,96.016,592.362,94.316,583.362z`,
        "aria-label": "Front right wrist",
    },
    [BodyPartsFront.RightHand]: {
        d: `M68.116,617.262c-13.4,3.8-33.1,20.2-37.8,23.2s-7.8,8.4-11.9,10.5s-4.1,8.6,0,10.5s9.6,0.1,13-1.5
    s9-8.5,15.5-10.5c3.8-1.2,7.6-1.5,7.6,0.1s-8.5,22.4-9.1,25.5s-3.9,13.9-5.9,21.1s-5.5,21.2-6.8,29.2s0.9,11.8,5.1,12.6
    s7.9-7.6,8.6-10.6s2.9-12.8,4-15.5s6.6-18.8,8-22s2.4-8.6,4.4-7.8c2,0.8-0.4,5.9-1.8,9.8s-7.1,24.8-7.9,28.6s-5,19.8-5.2,22.5
    s-1.9,8.8,2.8,10.5s7.8-1.9,9.5-5.6s5.4-17.6,7.4-26.1s5.8-19.5,7.1-24s2.1-8,3.9-7.9s1.5,2.5,0.8,4.8s-6.1,20.7-7.1,25.7
    s-4.2,16.1-5.4,20.4s-1.8,9.2,2.5,10.8s6.9-1.5,8.8-4.8s7.9-21.5,9.4-27.1s4.8-18.5,6.1-22.4s2.5-5.6,3.6-5.5s0.2,2.6-1.1,7
    s-5.4,18.5-7.1,25s-2.2,9.6,0,12s7.1-0.5,8.2-2.5s3-11,5.7-16.3c1.7-3.4,3.7-11.2,6.5-19.4c1.7-4.8,4.3-9.7,5.6-13.8
    c3.5-11,4.3-18.8,7-28.5s0.2-11.7,1-20.2c0.1-1,0.3-2.2,0.7-3.5c-14-10.8-34-19-43-19.4
    C78.916,613.762,75.516,615.161,68.116,617.262z`,
        "aria-label": "Front right hand",
    },
    [BodyPartsFront.LeftShoulder]: {
        d: `M527.216,261.362c-13-16.4-53.1-26.8-63.6-26.7c-5,4.9-14.4,9-25.3,10l-0.1,0.1c-4.6,0.4-9.5,0.4-14.4-0.4
    c-1.4-0.2-3-0.4-4.8-0.5c2.2,29.1,1.4,58.2-2.2,87.3c51.8-0.7,99.1-2.4,128.6-5.1C546.116,306.662,539.416,276.662,527.216,261.362z`,
        "aria-label": "Front left shoulder",
    },
    [BodyPartsFront.LeftArm]: {
        d: `M573.116,412.662c-1.6-11.2-17.9-51.2-22-57.2c-2.3-3.3-4.5-6-5.7-11.1v-0.1c-0.8-3.4-1-7.9-0.3-14.4
    c0.1-1.2,0.2-2.5,0.3-3.9c-12.3,1.1-27.6,2.1-45,2.9c-3,13.4-5.8,27.1-8.1,41c-1.4,8.2-2.7,16.6-3.9,25l0,0l0,0
    c0.1,0.1,20.8,42.7,23.5,48.2c1.7,2.7,3.8,4.6,6.1,6c8.9,5.4,21.2,2,32-2.5C564.216,440.562,575.816,431.962,573.116,412.662z`,
        "aria-label": "Front left arm",
    },
    [BodyPartsFront.LeftElbow]: {
        d: `M606.316,486.062c-2-7.9-5-16.4-9-24.1c-5-9.3-16.4-30.1-17.7-32.2c-3.2-5.2-5.3-9.2-6.5-17.2
    c2.7,19.3-8.9,27.9-23.2,33.9c-13.6,5.7-29.6,9.6-38.1-3.5c2.7,5.5,7,11.3,7,17.3c0,1.4,1.7,13.8,4.4,25.4
    c2.2,9.4,5.4,18.2,6.1,20.1C527.816,492.862,591.816,448.862,606.316,486.062z`,
        "aria-label": "Front left elbow",
    },
    [BodyPartsFront.LeftForearm]: {
        d: `M633.116,581.961c-2.9-7.6-5.9-16.1-8.1-21.6c-4-10-12.8-51-18.8-74.2c-14.5-37.2-78.5,6.8-77,19.8
    c7,18,35.8,60.2,40.4,65.9s16.5,23,19.5,28.2C595.716,610.161,635.016,591.562,633.116,581.961z`,
        "aria-label": "Front left forearm",
    },
    [BodyPartsFront.LeftWrist]: {
        d: `M649.116,612.062c-8.5-4-5.8-8.2-9.5-15c-1.7-3.1-4-8.8-6.4-15.2c1.8,9.6-37.4,28.2-44,18.1
    c1.5,2.7,5.2,10.5,8.5,17.7c3.2,6.8,6,13.1,6.5,14C619.116,619.661,640.616,611.562,649.116,612.062z`,
        "aria-label": "Front left wrist",
    },
    [BodyPartsFront.LeftHand]: {
        d: `M702.516,642.062c-2.8-3.8-17.5-11.5-21.8-14.5c-2.1-1.5-7.9-4.4-14.3-7.4s-13.2-6.1-17.5-8.1
    c-8.4-0.6-30,7.6-44.9,19.5c1,1.8-0.9,7.1,0.1,16.2s4.1,23.2,6.4,32.1s7,18.4,8.5,22.9s9.4,29.4,12.6,32c2.8,2.2,7.5,0.8,8.2-2.8
    s-1.6-10.9-2.5-14.1s-5.6-19.2-6.5-21.8s-2-5.1-0.2-5.1s2.1,2.8,3.2,5.6s5.9,19.5,6.9,24.1s4.5,17,6.2,21.8s5,10,9,9.8
    s4.9-4.8,5.1-8.4s-5.9-23.5-6.4-27.6s-5.4-19.2-6.1-21.2s-1.4-5,0.6-5.1s2.9,5.6,3.8,8.6s9.8,31.9,10.2,35.5s2.6,14.5,6,17.8
    c2.7,2.6,5.6,3.9,8.6,0.9s2.2-10,0.9-15.2s-4.6-21.1-5.5-25s-6.4-20.9-7.2-24s-2.1-5.4-1.1-5.8s2.2,1.1,3.5,5.2s6.6,20.5,8.4,25.5
    s1.5,11.6,4.1,17.4s7,7.6,10.6,7.1s4.3-7.4,4.4-10.1s-4.8-20.5-6.2-27.4s-5.2-16.6-6.5-23s-7.4-23.4-8.6-26s-0.6-4.8,2.5-3.9
    s9.2,2.6,13,7.6s10.9,6.8,13.4,7s8.5,0.4,9.2-6.4S705.316,645.862,702.516,642.062z`,
        "aria-label": "Front left hand",
    },
    [BodyPartsFront.UpperSternum]: {
        d: `M373.016,248.662c-1.8,2.8-5.3,4.2-8.9,4.4c-4.2,0.2-8.6-1.2-10.8-4.4c-4.2-5.8-29.3-4.5-44.9-3.7
    c-2.1,28.7-1.3,57.4,2.3,86.2c34.7,0.5,71.4,0.5,106,0c3.7-29.1,4.4-58.2,2.2-87.3C404.016,242.562,376.416,243.262,373.016,248.662
    z`,
        "aria-label": "Front upper sternum",
    },
    [BodyPartsFront.LowerSternum]: {
        d: `M328.916,331.262c0.5,7.1,1.1,14.2,1.5,21.3c1,15.7,1.7,31.5,2.1,47.1c20.7,1.2,41.5,1.2,62.2,0c0.4-15.9,1.2-31.9,2.2-47.9
    c0.4-6.9,0.9-13.7,1.5-20.6C375.316,331.462,351.816,331.462,328.916,331.262z`,
        "aria-label": "Front lower sternum",
    },
    [BodyPartsFront.Epigastric]: {
        d: `M394.116,438.162c0-5.4,0-10.9,0.1-16.3c0.1-7.3,0.2-14.7,0.5-22c-20.7,1.2-41.5,1.2-62.2,0c0.2,7.6,0.4,15.2,0.5,22.7
    c0.1,5.3,0.1,10.5,0.1,15.7c0,13.5-0.2,27-0.6,40.5c20.8,1.8,41.5,2,62.3,0.7C394.316,465.662,394.116,451.962,394.116,438.162z`,
        "aria-label": "Front epigastric",
    },
    [BodyPartsFront.RightRibs]: {
        d: `M332.916,422.462c-0.1-7.6-0.2-15.1-0.5-22.7c-0.4-15.7-1.1-31.4-2.1-47.1c-0.4-7.1-1-14.2-1.5-21.3
    c-6.1-0.1-12.1-0.1-18-0.2h-0.1c-30.4-0.4-59.2-1.2-83.9-2.3c3.3,14.5,6.2,29.3,8.7,44.4c1.2,7,2.2,14,3.2,21c0,0.1,0.1,0.2,0.3,0.5
    v-0.1c1.6,3.6,9.6,25.1,11.9,30.3c1.2,2.8,2.5,7.2,3.9,11.8c1.4,4.6,2.9,9.4,4.7,12.8v0.1c3.3,6.5,2.1,11.5,3.6,17
    c1,0.3,2,0.5,3,0.8c22.1,5.5,44.2,9.3,66.3,11.2c0.4-13.5,0.6-26.9,0.6-40.5C333.116,432.962,333.016,427.762,332.916,422.462z`,
        "aria-label": "Front right ribs",
    },
    [BodyPartsFront.LeftRibs]: {
        d: `M416.816,331.062h-0.1c-6.1,0.1-12.2,0.1-18.3,0.2c-0.5,6.9-1,13.7-1.5,20.6c-1,16-1.7,31.9-2.2,47.9
    c-0.2,7.4-0.4,14.7-0.5,22c-0.1,5.5-0.1,10.9-0.1,16.3c0,13.8,0.2,27.5,0.6,41.2c22.8-1.5,45.6-4.9,68.4-10.3
    c0.3-0.1,0.6-0.1,0.9-0.2c0.6-4.6,1.3-8.9,1.4-11.6c0.2-6.1,4.2-13.2,5.5-16.5c0.5-1.3,1.4-3.7,2.4-6.1c1.3-3.4,2.6-7,2.9-8.9
    c0.5-3.2,2.7-7,4.1-9.7c1.4-2.8,7.5-21.6,8-21.2c1.2-8.4,2.5-16.7,3.9-25c2.4-13.9,5.1-27.6,8.1-41
    C475.816,329.962,447.016,330.662,416.816,331.062z`,
        "aria-label": "Front left ribs",
    },
    [BodyPartsFront.Umbilical]: {
        d: `M332.516,478.662c-0.7,23.4-1.9,46.6-3.8,69.8c23.3,2.3,46.6,2.5,69.9,0.7c-1.9-23.1-3.2-46.4-3.8-69.8
    C374.016,480.762,353.216,480.462,332.516,478.662z`,
        "aria-label": "Front umbilical",
    },
    [BodyPartsFront.Pelvis]: {
        d: `M328.716,548.461c-1.9,24.1-4.5,48.1-7.7,71.8c28.5,8,56.9,8.1,85.4,0.1c-3.2-23.5-5.8-47.3-7.7-71.2
    C375.316,550.961,352.016,550.762,328.716,548.461z`,
        "aria-label": "Front pelvis",
    },
    [BodyPartsFront.Pubis]: {
        d: `M406.316,620.362c-28.5,8-56.9,8-85.4-0.1c-1,7.6-2.1,15.2-3.3,22.7c16.5,19.2,29.7,39,39.1,58.5c1-1.9,2.8-2.4,6.6-2.8
    c0.3,0,0.5,0,0.8,0c3.5-0.1,5,0.9,6.1,1.6c0.2,0.2,0.5,0.4,0.8,0.8c9.4-19.3,22.4-38.8,38.7-57.8
    C408.416,635.661,407.316,628.062,406.316,620.362z`,
        "aria-label": "Front pubis",
    },
    [BodyPartsFront.RightLumbar]: {
        d: `M266.216,467.462c-1-0.3-2-0.5-3-0.8c0.1,0.3,0.1,0.5,0.2,0.8c0.2,0.6,0.4,1.2,0.6,2c1.8,6.9,4,21.3-0.1,39.5
    c-2.4,10.8-2.7,20.3-2.3,27.4c0.4,6.2,1.3,10.7,1.8,12.8c0.8,3,2.3,5,1.4,8.8l-0.1-0.1c-0.4,1.9-1.5,4.1-3.4,7.2
    c-2.1,3.2-3.9,10.6-5.4,19.1c-0.1,0.4-0.1,0.9-0.2,1.4c23.9,17.9,44.7,37.4,61.9,57.5c1.2-7.6,2.3-15.1,3.3-22.7
    c3.2-23.8,5.8-47.7,7.7-71.8c1.9-23.1,3.1-46.4,3.8-69.8C310.416,476.762,288.316,473.062,266.216,467.462z`,
        "aria-label": "Front right lumbar",
    },
    [BodyPartsFront.LeftLumbar]: {
        d: `M472.116,583.661c-2.6-10.8-6.9-21.5-8.1-24.8v-0.1c-1.6-4.4-0.6-11.5,2.2-20.3c0.1-0.3,0.2-0.6,0.3-0.9
    c3-9.2-3.5-44.7-3.8-52.8c-0.2-4.2,0.4-9.7,1.2-15c0-0.3,0.1-0.6,0.1-0.9c-0.3,0.1-0.6,0.1-0.9,0.2c-22.8,5.3-45.6,8.8-68.4,10.3
    c0.7,23.4,2,46.7,3.8,69.8c1.9,23.9,4.5,47.6,7.7,71.2c1,7.7,2.2,15.3,3.3,22.9c17.4-20.4,38.5-40.1,62.8-58.2
    C472.316,584.562,472.216,584.062,472.116,583.661z`,
        "aria-label": "Front left lumbar",
    },
    [BodyPartsFront.RightCrotch]: {
        d: `M317.616,642.961c-17.2-20.1-38.1-39.6-61.9-57.5c-0.4,2.2-0.7,4.5-1.1,6.8c-2,14.4-3.1,29.6-2.8,34c0.4,5.6-3,26-6.7,45.9
    c23.3,3.2,45.1,8.7,64.8,16.1c15.7,6,30.1,13.1,42.7,21.4c0.8-4.9,3-6.2,3.8-7.9h0.1c0.1-0.1,0.1-0.3,0.2-0.4
    C347.316,681.961,334.116,662.262,317.616,642.961z`,
        "aria-label": "Front right crotch",
    },
    [BodyPartsFront.RightThigh]: {
        d: `M352.716,735.461c-0.9-4.4-0.2-12.7-0.4-21.3c0-1.7,0.1-3.2,0.3-4.4c-12.6-8.3-27-15.5-42.7-21.4
    c-19.7-7.4-41.5-12.9-64.8-16.1c-0.9,4.8-1.8,9.5-2.7,14c-0.7,3.5-1.4,6.9-2,10.1c-4,19.1-12.1,56.9-14.4,92.5
    c-0.6,9.1,0.2,18.1,0.4,26.5c0.8,35.1,9.5,55.5,16.1,69.4c35.7,13.2,53.8,56.8,88.5,34.4c2.5-11.2,8-40,9.6-52.3
    c1.8-13.5,10.1-66.3,11.8-88.2C354.016,756.762,353.616,739.862,352.716,735.461z`,
        "aria-label": "Front right thigh",
    },
    [BodyPartsFront.RightKnee]: {
        d: `M242.416,884.762c1.2,2.6,2.4,4.9,3.4,7.1c6.5,14,6,37.5,6.5,61c0.1,3.7,0.3,7.7,0.3,11.9
    c10.6,44.4,51,21.2,68.9,3.9c0.3-1.3,0.9-2.7,1.4-3.5c0.9-1.6,2.1-10.6,3.4-16.6s2-18.5,4-26.8c0.2-0.7,0.4-1.6,0.6-2.7
    C296.216,941.562,278.116,897.961,242.416,884.762z`,
        "aria-label": "Front right knee",
    },
    [BodyPartsFront.RightLeg]: {
        d: `M252.616,964.762c0.1,4.2,0.1,8.6-0.2,13.1c-1.4,20.2-4.8,41.9-4.1,53c1,16,4.5,62,7.5,83c3,21,6.9,83,7.1,87.5
    c0.1,1.1,0,2.3-0.1,3.5c7-11.5,36.5-9.9,44.8-6.1c-1.1-3.9-2.3-10.5-2.4-15c-0.2-5.3,7.5-47.2,8.3-58.3s3.7-29.5,4.3-33.3
    s5.8-17.2,9.5-25.9s3.5-20,2.5-27.2s-3.8-45.8-4.5-51.4s-2.2-13.1-3.5-15.1c-0.6-1-0.6-2.3-0.2-3.6
    C303.716,985.961,263.216,1009.262,252.616,964.762z`,
        "aria-label": "Front right leg",
    },
    [BodyPartsFront.RightAnkle]: {
        d: `M262.816,1204.862c-0.4,3.8-1.4,8.1-1.8,11.1c-0.5,4,2.1,8.6,1.4,15.9c0,0.3-0.1,0.7-0.1,1
    c12.7-4.4,40.2,8.7,49,21.1c1.2-7.8,1.1-15.2-0.5-19.1c-1.7-4.2-2.2-7.2-0.8-12.5s-0.7-18.7-1.8-21.8c-0.2-0.5-0.4-1.1-0.6-1.8
    C299.316,1194.962,269.816,1193.362,262.816,1204.862z`,
        "aria-label": "Front right ankle",
    },
    [BodyPartsFront.RightForefoot]: {
        d: `M262.316,1232.862c-1.1,7-6.7,15.4-10.9,23.7c-4.4,8.8-13,19.4-21,28.2s-10.4,26.4-10.1,29.5s3.1,5.9,6.1,5.5
    c0,1.1,1,2.9,4.2,2.5c0.2,2,0,6.2,8.2,5c4,4.9,7.9,4.6,10.8,1.8c5.3,6.3,10.4,6.5,15.8,5.8c4.4-0.6,11.1-7.8,12.2-10.6
    s2.2-3.9,5.9-6.8c2-1.6,3.8-4.1,5.2-8.8c1.1-4,2-10.1,2.3-12.8c0.7-5.8,0.7-10.8,4.5-21.3c8.7-3.7,14-10.3,15.5-18.8
    c0.1-0.6,0.2-1.3,0.3-1.9C302.516,1241.562,274.916,1228.462,262.316,1232.862z`,
        "aria-label": "Right forefoot",
    },
    [BodyPartsFront.LeftCrotch]: {
        d: `M479.316,648.562c-2.2-9.9-4.3-40-5.3-53.7l0,0c-0.2-3.1-0.8-6.5-1.6-9.8c-24.3,18.1-45.4,37.9-62.8,58.2
    c-16.3,19-29.3,38.5-38.7,57.8c1.1,1.6,2.6,4.9,3.5,7.3c0.1,0.3,0.2,0.8,0.3,1.5c12.6-8.2,26.9-15.4,42.5-21.4
    c20.1-7.6,42.5-13.2,66.4-16.4C481.716,660.762,480.016,651.661,479.316,648.562z`,
        "aria-label": "Front left crotch",
    },
    [BodyPartsFront.LeftThigh]: {
        d: `M501.516,789.062c-1-20.5-3.8-40.4-5.2-47.8c-1.6-8.9-7.9-44.2-12.4-68.8c0-0.1,0-0.2-0.1-0.3c-23.9,3.1-46.3,8.7-66.4,16.4
    c-15.7,5.9-29.9,13.1-42.5,21.4c0.8,5.3,0.5,20.5-0.5,30c-1.2,10.7,1.5,59.8,3.8,71s8.4,55.3,10.1,67s5.2,31.5,7.2,39.8
    c36.3,25.8,52.5-20,89.3-33.2c5.7-10,14-27.3,16-52.3C501.616,821.262,502.316,804.961,501.516,789.062z`,
        "aria-label": "Front left thigh",
    },
    [BodyPartsFront.LeftKnee]: {
        d: `M395.316,917.661c2,8.3,4.3,14.2,4.3,24s4,22.2,5.2,25c17.4,18.2,61,46.8,69.2-8.8c0-11.5,3.2-39.3,3.6-50.3
    s1.3-13,7-23C447.816,897.661,431.616,943.562,395.316,917.661z`,
        "aria-label": "Front left knee",
    },
    [BodyPartsFront.LeftLeg]: {
        d: `M404.816,966.661c1.2,2.8-1.2,16.4-4.2,33.9s-4.1,48.8-3.1,56.8s9.7,28.8,11.8,35s0.7,8.8,2,20.8s7.2,47.3,9,59
    s1.5,21-0.7,27.2c6.7-4.5,42.7-7,46.2,8.5c-0.8-4.2-1.8-10-1-22.2s5-60.2,8.2-87.8s6.8-82,4.5-96.5s-3.5-32-3.5-43.5
    C465.816,1013.562,422.216,984.862,404.816,966.661z`,
        "aria-label": "Front left leg",
    },
    [BodyPartsFront.LeftAnkle]: {
        d: `M419.616,1199.362c-2.2,6.2-3.2,21-2.7,22.7s0.8,9.3-1,13.5s-1.7,13.3-0.7,21.5c6-13.6,37-29.9,50-23.7
    c-2-5.5-2.2-5.8-1-9.2s2.2-12,1.5-16.2C462.316,1192.362,426.316,1194.862,419.616,1199.362z`,
        "aria-label": "Front left ankle",
    },
    [BodyPartsFront.LeftForefoot]: {
        d: `M415.316,1257.062c1,8.2,12,15,15,16.5s3,4.2,3.8,7s2.8,10.7,3.8,21s6.2,15.7,8.7,17.7s2.8,3,3.7,4.7
    s3.4,6.1,11.2,9.8s15-1.2,16.7-4.8c4.5,4.5,11.1,0.4,12.2-2.1c4.9,1.4,7.8-3.2,7.9-5.2c1.6,0.3,3.6-1.1,4.2-2.6
    c0.8,0.3,2.5,0.7,5-3.3s-3-17.5-4.2-21.7s-9.7-14.8-16.3-21.8s-7.8-11.3-12.5-18.7s-7.3-14.7-9.3-20.2
    C452.316,1227.062,421.316,1243.462,415.316,1257.062z`,
        "aria-label": "Left forefoot",
    },
};
const FrontMaleBodyParts = (props) => {
    return React.createElement(BodyParts, Object.assign({ image: React.createElement(MaleImage, { href: image }), paths: paths }, props));
};
export default FrontMaleBodyParts;
//# sourceMappingURL=FrontMaleBodyParts.js.map